import oneImage from "../../images/iconsSteps/one.png";
import twoImage from "../../images/iconsSteps/two.png";
import threeImage from "../../images/iconsSteps/three.png";
import fourImage from "../../images/iconsSteps/four.png";
import fiveImage from "../../images/iconsSteps/five.png";
import sixImage from "../../images/iconsSteps/six.png";

const data = [
  {
    id: 1,
    icon: oneImage,
    title: "الاتصال بك",
    desc: "أخبرنا بأي شئ تريد تصميمه",
  },
  {
    id: 2,
    icon: twoImage,
    title: "الخطة",
    desc: "أخبرنا بأي شئ تريد تصميمه",
  },
  {
    id: 3,
    icon: threeImage,
    title: "التصميم",
    desc: "تصميم الواجهات تصميم مرن و فعال مع المستخدم",
  },

  {
    id: 4,
    icon: fourImage,
    title: "البرمجة",
    desc: "أخبرنا بأي شئ تريد تصميمه",
  },
  {
    id: 5,
    icon: fiveImage,
    title: "الفحص النهائى",
    desc: "سوف نقوم بفحص الكود و تأمينه من الثغرات ",
  },
  {
    id: 6,
    icon: sixImage,
    title: "النشر",
    desc: "سوف نقوم برفع التطبيق او الموقع و نشرة لتبدا بجني الارباع",
  },
];

export default data;
